<template>
  <div :class="{ 'form-data__error': error }" class="form-data">
    <div class="upper-label" :class="{ 'upper-label__error': serverError }">
      {{ serverError ? errorLabel : label }}
    </div>
    <date-picker
      v-model="inputValue"
      :not-after="notAfter"
      :not-before="notBefore"
      :popup-style="popupStyle"
      lang="ru"
      :type="type"
      :format="format"
      :confirm="confirm"
      :range="range"
      :range-separator="rangeSeparator"
      :shortcuts="shortcuts"
      :confirm-text="confirmText"
      :placeholder="placeholder"
      :clearable="clearable"
      :disabled="disable"
      @change="keymonitor"
    />
    <div :class="{ 'input-info__error': error }" class="input-info">{{ bottomInfo }}</div>
    <div class="error-input-info">{{ errorInfo }}</div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";

export default {
  name: "FormSimpleDate",
  components: { DatePicker },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    serverError: {
      type: Boolean,
      default: false
    },
    /* eslint-disable-next-line vue/require-default-prop */
    inputModel: {
      type: [String, Number, Array, Date]
    },
    fieldname: {
      type: String,
      default: ""
    },
    keymonitor: {
      type: Function,
      default: () => {}
    },
    update: {
      type: Function,
      default: () => {}
    },
    label: {
      type: String,
      default: ""
    },
    errorLabel: {
      type: String,
      default: ""
    },
    bottomInfo: {
      type: String,
      default: ""
    },
    errorInfo: {
      type: String,
      default: ""
    },
    notAfter: {
      type: [String, Date],
      default: ""
    },
    notBefore: {
      type: [String, Date],
      default: ""
    },
    popupStyle: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: "date"
    },
    format: {
      type: String,
      default: "DD.MM.YYYY"
    },
    confirm: {
      type: Boolean,
      default: false
    },
    range: {
      type: Boolean,
      default: false
    },
    rangeSeparator: {
      type: String,
      default: "~"
    },
    shortcuts: {
      type: Boolean,
      default: true
    },
    confirmText: {
      type: String,
      default: "Применить"
    },
    placeholder: {
      type: String,
      default: "Выберите дату"
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.inputModel;
      },
      set(newValue) {
        this.$emit("update", {
          value:
            !this.range && (this.format === "DD.MM.YYYY" || this.format === "YYYY-MM-DD") ? this.getDate(newValue) : newValue,
          fieldname: this.fieldname
        });
      }
    }
  },
  methods: {
    getDate(d1) {
      if (!d1) {
        return d1;
      }
      const d = new Date(d1);
      const month = `0${d.getMonth() + 1}`;
      const date = `0${d.getDate()}`;
      return `${d.getFullYear()}-${month.slice(-2)}-${date.slice(-2)}`;
    },
    inputValueNotEmpty() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.reduce((acc, item) => {
          if (!item) {
            return false;
          }
          return true;
        }, true);
      }

      if (typeof this.inputValue === "string") {
        return this.inputValue.length > 0;
      }

      // is date?
      if (typeof this.inputValue === "number" || Object.prototype.toString.call(this.inputValue) === "[object Date]") {
        return true;
      }
    }
  }
};
</script>
